import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Box = styled.div`
  /* padding: 16px !important; // !!! color */
  /* border: 1px solid rgba(255, 255, 255, 0.06) !important; // !!! color */
  /* background: rgba(238, 238, 238, 0.03) !important; // !!! color */
  /* backdrop-filter: blur(50px) !important; // !!! color */
  /* color: #FFF !important; // !!! color */
`

const Widget = ({
  title = null,
  description = null,
  right = null,
  children,
  titleUppercase,
  className = ''
}) => {
  return (
    // TODO: check the global box styles after redesign all PWA
    /*<Box className={`widget  p-4 mb-4 rounded-lg bg-white border border-grey-100 dark:bg-grey-895 dark:border-grey-890 ${className}`}>*/
    <Box className={`widget mb-4 ${className}`}>
      {(title || description || right) && (
        <div className="flex flex-row items-start justify-between ">
          <div className="flex flex-col">
            <div className={`text-sm font-light text-grey-500 ${titleUppercase ? 'uppercase' : ''}`}>{title}</div>
            <div className="text-sm font-bold">{description}</div>
          </div>
          {right}
        </div>
      )}
      {children}
    </Box>
  )
}

Widget.propTypes = {
  title: PropTypes.any,
  titleUppercase: PropTypes.bool,
  description: PropTypes.any,
  right: PropTypes.any,
  children: PropTypes.any
}
export default Widget

export * from './dashboard'
export * from './WidgetInstalls'
